import { notificationStateVar } from 'shared/store/notification'
import { shortenAddress } from 'shared/utils/shorten-address'

const WALLET_OWNED_BY_ANOTHER_ACCOUNT = 'already used by another account'

export const getLinkWalletErrorMessage = (error: unknown): string => {
  const message = error instanceof Error ? error.message : String(error)

  if (message.includes(WALLET_OWNED_BY_ANOTHER_ACCOUNT)) {
    return 'This wallet belongs to another XYRO account and cannot be linked. A wallet that has already played without being linked belongs to its own account.'
  }

  return message || 'Wallet was not linked'
}

export const notifyLinkWalletError = (error: unknown) => {
  console.error('Failed to link wallet', error)
  notificationStateVar({
    isOpen: true,
    type: 'error',
    title: 'Wallet was not linked',
    description: getLinkWalletErrorMessage(error)
  })
}

export const notifyWalletLinked = (address: string) => {
  notificationStateVar({
    isOpen: true,
    type: 'success',
    title: 'Wallet linked',
    description: `${shortenAddress(address)} is linked and selected for play.`
  })
}
